var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c(_vm.pageCountry,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }